//license based  api url
export class globals {
  public constants = {
    // Constantes de métodos HTTP
    HTTP_METHOD_POST: "POST",
    HTTP_METHOD_GET: "GET",

    // Constantes de parámetros y cabeceras HTTP
    PARAMETER_GRANT_TYPE: "grant_type",
    PARAMETER_GRANT_TYPE_PASSWORD_VALUE: "password",
    PARAMETER_GRANT_TYPE_REFRESH_TOKEN_VALUE: "refresh_token",
    PARAMETER_CLIENT_ID: "client_id",
    //PARAMETER_CLIENT_ID_DEFAULT_VALUE: '',
    PARAMETER_CLIENT_SECRET: "client_secret",
    //PARAMETER_CLIENT_SECRET_DEFAULT_VALUE: '',
    PARAMETER_SCOPE: "scope",
    PARAMETER_SCOPE_DEFAULT_VALUE: "",
    PARAMETER_USERNAME: "email",
    PARAMETER_PASSWORD: "password",
    HEADER_ACCEPT: "accept",
    HEADER_ACCEPT_IMAGE: "image/*",
    HEADER_ACCEPT_JSON_VALUE: "application/json",
    HEADER_CONTENT_TYPE: "Content-Type",
    HEADER_CONTENT_TYPE_VALUE_APPLICATION_FORM_URL_ENCODED: "application/json",
    HEADER_REFRESH_TOKEN: "refresh_token",
    HEADER_AUTHORIZATION: "Authorization",
    HEADER_AUTHORIZATION_VALUE: "Basic SGVhbG1lQXBwOkhlYWxtZUFwcFNlY3JldA==",
    HEADER_ACCEPT_LANGUAGE: "Accept-Language",

    // Constantes de respuestas recibidas del servidor
    RESPONSE_ERROR_INVALID_TOKEN: "invalid_token",
    RESPONSE_ERROR_INVALID_GRANT: "invalid_grant",
    RESPONSE_ERROR_BAD_CREDENTIALS: "Bad credentials",

    // Constantes de local storage
    STORAGE_TOKEN_INFO: "tokenInfo",
    STORAGE_USER_INFO: "userInfo",

    // Paginado

    USERS_PER_PAGE: 100,

    // INFO DEGESCO

    MEDIUM_LIMIT_SCORE: "9",
    TOTAL_QUESTIONS: 30,

    // URL

    url_api: "/api",

    url_storage: "/storage/",

    url_final_user: "/final-users",
    url_final_user_index: "/",
    url_final_user_count: "/countusers",
    url_final_user_register: "/register",
    url_final_user_update: "/update/",
    url_final_user_delete: "/delete/",

    url_final_user_response: "/final-user-responses",
    url_final_user_response_add: "/add",
    url_final_user_response_delete_by_question: "/question/",
    url_final_user_search: "/search/",
    url_final_user_response_info_user: "/info/",
    url_final_user_response_multiple_users_info: "multiple",

    url_final_user_audio: "/final-user-audio",
    url_final_user_audio_add: "/add",
    url_final_user_audio_delete: "/delete/",
    url_final_user_audio_get_by_user: "/audios/",

    url_final_user_validate_email: "/validate-email",
    url_final_user_validate_nif: "/validate-nif",

    url_questions: "/questions",
    url_questions_step: "/step/",

    url_file: "/file",
    url_file_upload: "/upload",
    url_file_download: "/download/",

    url_oauth_login: "/login",
    url_oauth_is_authenticated: "/isAuthenticated",
    url_oauth_forgot_password: "/forgot-password",
    url_oauth_change_password: "/change-password",
    url_oauth_change_password_token_validation: "/validate-token",

    url_user: "/users",
    url_user_get_by_id: "/",
  };
}
